<template lang="pug">
  SmartTable.table(v-bind="table", name="routine-picker" v-model="tableData")
    template(v-slot:default="slotProps")
      TableRow(v-bind="slotProps")
        template(v-slot:name="{ columnValue, rowItem, index }")
          span.fs-13 {{ columnValue }}

        template(v-for="i in 7" v-slot:[`journey${i-1}`]="{ columnValue, rowItem, index }")

          span.jrn.fs-13(v-if="columnValue"
          :class="{[`background-${[columnValue.color]}`]: true}") {{ columnValue.name }}

</template>

<script>
import { rightJourneyTextAndColor } from 'src/utils'

export default {
  name: 'RoutinePicker',
  created () {
    this.$store.dispatch('common/routines/fetchItems')
  },
  props: {
    value: {type: Object, 'default': null}
  },
  data () {
    return {
      table: {
        headerItems: [
          {column: 'escala', field: 'name', width: '1fr', userCustom: {hiddable: false}},
          {column: 'dias trab.', field: 'workDays', width: '0.7fr'},
          {column: 'dias folga', field: 'offDays', width: '0.7fr'},
          {column: '1º', field: 'journey0', width: '0.5fr'},
          {column: '2º', field: 'journey1', width: '0.5fr'},
          {column: '3º', field: 'journey2', width: '0.5fr'},
          {column: '4º', field: 'journey3', width: '0.5fr'},
          {column: '5º', field: 'journey4', width: '0.5fr'},
          {column: '6º', field: 'journey5', width: '0.5fr'},
          {column: '7º', field: 'journey6', width: '0.5fr'}
        ],
        config: {
          perPage: 5,
          defaultSortField: 'name',
          defaultColumnSearch: 'name',
          detailsBox: {
            openOnClickRow: false
          }
        }
      }
    }
  },
  computed: {
    routines () {
      return this.$store.state.common.routines.items
    },
    tableData: {
      get () {
        let routines = []

        if (this.routines) {
          routines = this.routines
            .map(i => {
              const journeys = {
                journey0: null,
                journey1: null,
                journey2: null,
                journey3: null,
                journey4: null,
                journey5: null,
                journey6: null
              }

              i.journeys.slice(0, 7).forEach((jrn, index) => {
                const temp = rightJourneyTextAndColor(jrn)

                journeys[`journey${index}`] = {name: temp.text, color: jrn.color}
              })

              return {...i, ...journeys}
            })
        }

        return {
          loaded: routines,
          selected: {
            item: this.value.index !== null ? this.routines[this.value.index] : null,
            index: this.value.index
          }
        }
      },
      set (value) {
        this.$emit('input', {
          index: value.selected.index,
          selected: this.routines[value.selected.index]
        })
        this.$emit('selected', {selected: this.routines[value.selected.index]})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  @keyframes marquee {
    0% { text-indent: 0px }
    100% { text-indent: -9em }
  }

  .body-column {
    cursor: pointer !important;
  }

  .jrn {
    display: grid;
    text-align: center;
    padding: 4px;
    align-items: center;
    span {
      text-align: center;
    }
  }

  .routine-name {
    overflow: hidden;
    justify-items: center;
    min-width: 0;
    padding-left: 5px;
    text-align: left !important;
    box-sizing: border-box;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:not(:hover) {
      -webkit-animation: notexistent;
      animation: notexistent;
    }
    &:hover {
      animation-play-state: running;
      animation: marquee 7s linear infinite;
    }
  }
}
</style>
